var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reward-token-box"},[_c('img',{attrs:{"src":_vm.icon,"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.token))])])}
var staticRenderFns = []

export { render, staticRenderFns }